/** Possible placements of the OAI button on the learn page. */
export enum OaiPlacement {
  HEADER = 'header',
  VIDEO = 'video',
}

/**
 * Shape of the `/api/learnPageABTest` response. Currently empty (no active
 * learn-page A/B tests) — extend with one field per active test (e.g.
 * `foo: FooVariant`) when a resolver is added.
 */
export type LearnABTestData = Record<string, never>;

/** Default response when no test buckets the visitor. */
export const LEARN_AB_TEST_DEFAULT: LearnABTestData = {};
/** A/B test name persisted in `ab_test_users`. */
export const LEARN_PAGE_VERSION_TEST = 'learn-page-version';

/** OAI program codes eligible for the learn page redesign A/B test. */
export const LEARN_OAI_PROGRAMS = ['MD', 'DO', 'OH', 'PA'];

/**
 * Nursing product codes. The Osmosis AI button is hidden on library pages for
 * these products (NP, LPN, RN).
 *  */
export const NURSING_PRODUCT_KEYS = ['NP', 'LPN', 'RN'];

/**
 * Case-insensitive check for whether a library product key is a nursing
 * product. Accepts both the store product key (e.g. `RN`) and the lowercase
 * URL segment (e.g. `rn`). A falsy key returns false.
 */
export const isNursingProduct = (productKey?: string | null): boolean =>
  !!productKey && NURSING_PRODUCT_KEYS.includes(productKey.toUpperCase());
